import * as types from "./mutation_types";

export default {
  [types.FONCTIONETP_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
    });
  },

  [types.FONCTIONETP_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.FONCTIONETP_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.FONCTIONETP_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
